import slugify from "slugify";
import { FavoriteStorage, getGenericData, SearchedStorage } from "./local-storage-functions";
import LocalStorageHelper from "./local-storage-helper";

const Elements = {
  desktopAutocomplete: $('#desktopSearchAutocomplete'),
  mobileAutocomplete: $('#mobileSearchAutocomplete'),
  mobileSearchButton: $('#bt_modalSearch_mobile'),
  desktopInput: $('#searchGeneral'),
  mobileInput: $('#mobileSearchInput'),
  mobileUl: $('#mobileAutocompleteSuggestions'),
  desktopUl: $('#autocompleteSuggestions'),
  mobileHeader: $('#mobileAutocompleteHeader'),
  desktopHeader: $('#autocompleteHeader'),
  mobileEmptyMessage: $('#mobileAutocompleteEmptyHistory'),
  desktopEmptyMessage: $('#autocompleteEmptyHistory'),
  mobileClearButton: $('#mobileAutocompleteHeaderClearButton'),
  desktopClearButton: $('#autocompleteHeaderClearButton'),
  myLocationButton: $('#autocompleteSearchMyLocation'),

  getUl() { return this.getIsDesktop() ? this.desktopUl : this.mobileUl; },
  getHeader() { return this.getIsDesktop() ? this.desktopHeader : this.mobileHeader; },
  getEmptyMessage() { return this.getIsDesktop() ? this.desktopEmptyMessage : this.mobileEmptyMessage; },
  getClearButton() { return this.getIsDesktop() ? this.desktopClearButton : this.mobileClearButton; },
  getInput() { return this.getIsDesktop() ? this.desktopInput : this.mobileInput; },
  getAutocomplete() { return this.getIsDesktop() ? this.desktopAutocomplete : this.mobileAutocomplete; },
  getIsDesktop() { return $(window).outerWidth() > 1199; }
};

export const keyByType = { city: 'city', beach: 'beach', airport: 'airport' };
export const idKeyByType = { city: 'idcity', beach: 'idbeach', airport: 'idairport' };
export const pathByType = { city: 'cidade', beach: 'litoral', airport: 'aeroporto' };
export const titleByType = { city: 'Cidades', beach: 'Praias', airport: 'Aeroportos' };


let isAutocompleteInitialized = false;
let currentSuggestions = [];
let isDesktopView = Elements.getIsDesktop();

export function autocomplete() {
  if (isAutocompleteInitialized) return;
  isAutocompleteInitialized = true;

  resizeEventHandler();
  searchButtonEventHandler();
  setupInputListener();
  setupDesktopClickListener();
  setupClickOutsideListener();
  renderSearchHistory();
}

function resizeEventHandler() {
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const wasPreviouslyDesktop = isDesktopView;
      isDesktopView = Elements.getIsDesktop();

      if (wasPreviouslyDesktop !== isDesktopView) {
        Elements.desktopAutocomplete.hide();
        Elements.mobileAutocomplete.hide();
        removeInputListeners();
        setupInputListener();
        setupDesktopClickListener();
        renderSearchHistory();
      }
    }, 50);
  });
}

function searchButtonEventHandler() {
  const searchButton = Elements.mobileSearchButton;
  searchButton.on('click', () => {
    const container = Elements.getAutocomplete();
    const isVisible = container.css('display') === 'flex';
    container.css('display', isVisible ? 'none' : 'flex');
    if (!isVisible) Elements.getInput().trigger('focus');
  });
}

function setupInputListener() {
  const handler = createDebouncedInputHandler();
  Elements.desktopInput.on('input', handler);
  Elements.mobileInput.on('input', handler);
}

function removeInputListeners() {
  Elements.desktopInput.off('input click');
  Elements.mobileInput.off('input');
}

function createDebouncedInputHandler() {
  return debounce(async function () {
    const input = $(this).val()?.trim();
    const ul = Elements.getUl();
    const header = Elements.getHeader();
    const emptyMessage = Elements.getEmptyMessage();

    if (!input) {
      ul.hide().empty();
      emptyMessage.css('display', 'flex');
      header.css('display', 'flex');
      renderSearchHistory();
      return;
    }

    if (input.length < 3) return;

    try {
      const response = await $.ajax({
        url: '/json/busca-por-nome',
        type: "POST",
        dataType: "json",
        cache: true,
        data: { name: input }
      });

      treatResponse(response);
    } catch (error) {
      console.error("Erro na busca:", error);
    }
  }, 300);
}

function treatResponse(response) {
  const validTypes = ['city', 'beach', 'airport'];

  const sliced = response
    .map(({ response: { data }, type }) => {
      const normalizedType = type?.toLowerCase();
      return {
        places: Array.isArray(data) ? data.slice(0, 5) : [],
        type: normalizedType
      };
    })
    .filter(({ type }) => validTypes.includes(type));

  currentSuggestions = sliced;
  renderSuggestions(sliced);
}

function renderSearchHistory(type = 'city') {
  const history = SearchedStorage.get();
  const ul = Elements.getUl();
  const header = Elements.getHeader();
  const empty = Elements.getEmptyMessage();

  ul.empty();
  if (!history.length) {
    header.hide();
    ul.hide();
    empty.show();
    return;
  }

  header.show();
  empty.hide();
  ul.show();

  history.forEach((raw) => {
    if (raw?.city) {
      const place = LocalStorageHelper.unmapCityData(raw.city);
      const meta = buildCityMeta(place, type);
      const icon = $('<img src="/dist/images/v2/svg/history.svg" alt="Histórico">');

      const favButton = createFavoriteButton(raw.city);

      const li = createListItem({ label: meta.label, href: meta.href, icon, favButton });
      ul.append(li);
    }
  });
}

function renderSuggestions(suggestions) {
  const ul = Elements.getUl();
  const header = Elements.getHeader();
  const empty = Elements.getEmptyMessage();

  ul.empty().show();
  header.hide();
  empty.hide();

  let index = 0;
  suggestions.forEach(({ places, type }) => {
    if (!places.length) return;

    ul.append($('<h6>').text(titleByType[type]));

    places.forEach((place) => {
      index++;
      const meta = buildCityMeta(place, type);
      const cityData = LocalStorageHelper.mapCityData(place);
      const favButton = createFavoriteButton(cityData);
      const genericData = getGenericData('search')
      const data = {
        ...genericData,
        city: cityData
      }
      const a = $('<a>').attr('href', meta.href).on('click', () => {
        SearchedStorage.append(data, 10, 'cid', 'city');
      });

      const li = createListItem({ label: meta.label, href: meta.href, favButton, linkElement: a });
      ul.append(li);
    });
  });

  if (Elements.getIsDesktop()) ul.css('padding-top', '8px');
}

function buildCityMeta(place, type) {
  const name = place[keyByType[type]];
  const uf = place.uf === 'ND' && place.ac ? place.ac : place.uf;
  const label = `${name} - ${uf}`;
  const slug = slugify(String(name)).replaceAll("-","").toLowerCase();
  const href = `/previsao-do-tempo/${pathByType[type]}/${place[idKeyByType[type]]}/${slug}-${uf.toLowerCase()}`;
  return { name, uf, label, href };
}

export function toggleFavorite(city) {
  const favorites = FavoriteStorage.get();

  const isCurrentlyFavorited = favorites.some(p => p?.city?.cid === city.cid);
  const willBeFavorited = !isCurrentlyFavorited;

  const genericData = getGenericData('favorite');

  const dataToSave = {
    ...genericData,
    city: city
  };

  if (isCurrentlyFavorited) {
    FavoriteStorage.remove({ cid: city.cid }, 'cid', 'city');
  } else {
    FavoriteStorage.append(dataToSave, 50, 'cid', 'city');
  }

  const event = new CustomEvent('favoriteChanged', {
    detail: {
      city: city,
      isFavorited: willBeFavorited
    }
  });
  document.dispatchEvent(event);
}

function createFavoriteButton(city) {
  const button = $('<button type="button" class="historyFavButton"></button>');
  const icon = $('<img>');
  button.append(icon);

  button.attr('data-cid', city.cid);

  function updateVisual(isFavorited) {
    const iconName = isFavorited ? 'star-filled' : 'star-empty';
    const title = isFavorited ? 'Remover dos favoritos' : 'Favoritar cidade';
    icon.attr('src', `/dist/images/v2/svg/${iconName}.svg`);
    button.attr('title', title);
  }

  updateVisual(FavoriteStorage.get().some(p => p.cid === city.cid));

  button.on('click', (e) => {
    e.stopPropagation();
    toggleFavorite(city);
  });

  document.addEventListener('favoriteChanged', (event) => {
    if (event.detail.city.cid === city.cid) {
      updateVisual(event.detail.isFavorited);
    }
  });

  return button;
}

function createListItem({ label, href, icon = null, favButton = null, linkElement = null }) {
  const li = $('<li class="autocomplete-item"></li>');
  const wrapper = $('<div class="autocomplete-content"></div>');
  const a = linkElement || $('<a></a>').attr('href', href);
  a.append($('<span></span>').text(label));
  if (icon) a.prepend(icon);

  const contentWrapper = $('<div></div>').append(a);
  wrapper.append(contentWrapper);
  if (favButton) wrapper.prepend(favButton);
  li.append(wrapper);
  return li;
}

function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

function setupDesktopClickListener() {
  const input = Elements.desktopInput;
  const container = Elements.desktopAutocomplete;

  input.on('click', (e) => {
    e.stopPropagation();
    container.css('display', 'flex');
  });
}

function setupClickOutsideListener() {
  $(document).on('click', (e) => {
    const container = Elements.desktopAutocomplete;
    const input = Elements.desktopInput;

    if (!container.is(e.target) && container.has(e.target).length === 0 && !input.is(e.target)) {
      container.hide();
    }
  });
}
